import * as React from "react"

import { ActionAnchor, ActionType } from "@tenforce/toolbox-button-push-react"
import { ItemBlockPart, Selector } from "@tenforce/toolbox-selector-react"
import { ReadOnly, FieldItems } from "@tenforce/toolbox-field-react"
import { RowContent, Cell, CellType } from "@tenforce/toolbox-table-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import env from "../../../env"
import { workspaceSettingsUrl } from "../../../util/UrlGenerator"
import { Workspace } from "../../../models"

interface Props {
    workspace: Workspace
}

export const WorkspaceRow = ({
    workspace: { code, id, isActive, label },
}: Props): JSX.Element => (
    <RowContent
        key={id}
        data-ft-workspace-row
        data-ft-workspace-title={label.toLowerCase()}
    >
        <Cell type={CellType.action}>
            <ActionAnchor
                href={workspaceSettingsUrl(env.applicationPath, id)}
                actionType={ActionType.block}
                title={label}
                extraClasses="tw-pl-6 text-black"
                data-ft-component="workspaceLink"
                data-ft-workspace-code={code.toLowerCase()}
            >
                <div className="tw-truncate">{code}</div>
            </ActionAnchor>
        </Cell>
        <Cell
            data-ft-component="workspace-title"
            data-ft-workspace-title={label.toLowerCase()}
        >
            <FieldItems>
                <ReadOnly value={label} title={label} />
            </FieldItems>
        </Cell>
        <Cell data-ft-component="is-active" data-ft-is-active={isActive}>
            <FieldItems>
                <Selector
                    isReadOnly={true}
                    data-ft-component="isActiveCheckbox"
                >
                    <ItemBlockPart isSelected={true}>
                        {isActive ? Symbols.Confirm : Symbols.Cancel}
                    </ItemBlockPart>
                </Selector>
            </FieldItems>
        </Cell>
    </RowContent>
)

export default WorkspaceRow
